export class FilterServiceModel {
  public displayFilter: boolean;
  public applyFilter: boolean;
  public clearFilter: boolean;
  public source: any;
  public visible: boolean;

  constructor(
    displayFilter: boolean,
    applyFilter: boolean,
    clearFilter: boolean,
    source: any[],
    visible: boolean
  ) {
    this.displayFilter = displayFilter;
    this.applyFilter = applyFilter;
    this.clearFilter = clearFilter;
    this.source = source;
    this.visible = visible;
  }
}
